__turbopack_context__.v({
  "container": "_3PPYNq_container",
  "followCount": "_3PPYNq_followCount",
  "followCountOwnShop": "_3PPYNq_followCountOwnShop",
});
